import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useFetchAuthorisation, useFetchUserData } from "../../utils/AppFunctions";
import { fetch_contact_form_by_id } from '../../api/contactAPI'
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layouts/AdminLayout";
import notify from "../../utils/IANotification";
import Card from "../../components/ui/Card";
import Button from "../../components/ui/Button";
import { MdArrowBack } from "react-icons/md";

export default function ContactFormPage() {
  const navigate = useNavigate();
  useFetchAuthorisation("user");
  useFetchUserData();

  let form_id = new URLSearchParams(window.location.search).get("form_id");
  const [contactForm, setContactForm] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchContactFormById = async () => {
    setLoading(true);
    if (!form_id) return setLoading(false)
    const { data, error, message, status } = await fetch_contact_form_by_id(form_id)
    if (error || status !== 200) {
      notify({ message: message || error, type: 'error' })
    } else {
      setContactForm(data || {})
    }
    setLoading(false);
  }

  useEffect(() => {
    if (form_id) {
      fetchContactFormById();
    }
  }, []);

  return (
    <AdminLayout
      navSelected={"Contact Form"}
      headerText="Contact Submission Submission"
      toolbar={
        <>
          <div className="flex items-center gap-3">
            <Button variant="outline" icon={MdArrowBack} onClick={() => navigate('/admin/contact')}>
              Back
            </Button>
            <h1 className='text-xl font-bold text-gray-900'>
              Inquiry from {contactForm.name || "User"}
            </h1>
          </div>
        </>
      }
    >
      <Card title="Submitted Contact Form Details" subtitle="View details submitted by website visitors via public contact form.">
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="input-container">
              <label className="input-label font-semibold">Sender Name</label>
              <input type="text" className="text-input bg-gray-50 cursor-not-allowed" disabled value={contactForm.name || ""} />
            </div>
            <div className="input-container">
              <label className="input-label font-semibold">Email Address</label>
              <input type="text" className="text-input bg-gray-50 cursor-not-allowed" disabled value={contactForm.email || ""} />
            </div>
            <div className="input-container">
              <label className="input-label font-semibold">Contact Number</label>
              <input type="text" className="text-input bg-gray-50 cursor-not-allowed" disabled value={contactForm.contact_number || ""} />
            </div>
          </div>

          <div className="input-container">
            <label className="input-label font-semibold">Message Inquiry</label>
            <textarea className="textarea-input h-48 bg-gray-50 cursor-not-allowed leading-relaxed" disabled value={contactForm.message || ""} />
          </div>
        </div>
      </Card>
    </AdminLayout>
  )
}